import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';

export function createTypesenseMappingInCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_BEGIN,
    });

    const { projectId, version, data, selectedCollection } = args;
    const { uuid: collectionUuid, typesenseMapping = [] } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/typesense-mapping/${collectionUuid}/collection`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          toast.success(
            typesenseMapping && typesenseMapping.length
              ? 'Typesense Mapping Updated Successfully !'
              : 'Typesense Mapping Created Successfully !',
          );
          dispatch({
            type: COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_SUCCESS,
            data: res,
          });
          Mixpanel.track(
            typesenseMapping && typesenseMapping.length
              ? 'Updated collection typesense mapping'
              : 'Created collection typesense mapping',
          );
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track(
            typesenseMapping && typesenseMapping.length
              ? 'Failed to update collection typesense mapping'
              : 'Failed to create collection typesense mapping',
          );
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateTypesenseMappingInCollectionError() {
  return {
    type: COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_BEGIN:
      return {
        ...state,
        createTypesenseMappingInCollectionPending: true,
        createTypesenseMappingInCollectionError: null,
      };

    case COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_SUCCESS:
      return {
        ...state,
        createTypesenseMappingInCollectionPending: false,
        createTypesenseMappingInCollectionError: null,
      };

    case COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_FAILURE:
      return {
        ...state,
        createTypesenseMappingInCollectionPending: false,
        createTypesenseMappingInCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_TYPESENSE_MAPPING_IN_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createTypesenseMappingInCollectionError: null,
      };

    default:
      return state;
  }
}
